import { useTranslation } from 'react-i18next';

import { Tab } from '../Tab';

import { Language } from './components/Language';
import { LogoForm } from './components/LogoForm';
import { StoreForm } from './components/StoreForm';
import { VisionProducts } from './components/VisionProducts';

import { ChangePasswordForm } from '@/components/ChangePasswordForm';

export function General() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.General',
  });

  return (
    <div className="space-y-8">
      <Tab title={t('generalTitle')} description={t('generalDescription')}>
        <Language />
        <LogoForm />
        <StoreForm />
        <VisionProducts />
      </Tab>

      <Tab title={t('securityTitle')} description={t('securityDescription')}>
        <ChangePasswordForm />
      </Tab>
    </div>
  );
}
